import {inject, Injectable, signal} from '@angular/core';
import {DialogService} from 'primeng/dynamicdialog';
import {TicketNoCategory} from './ticket-no-category';
import {DialogFooterComponent} from '../../../../shared/components/dialog-footer/dialog-footer';

@Injectable({
	providedIn: 'root'
})
export class TicketNoCategoryService {
	private dialogService: DialogService = inject(DialogService)

	private readonly openSig = signal(false);
	readonly isOpen = this.openSig.asReadonly();

	openNoCategoryDialog() {
		if (this.openSig()) return;

		this.openSig.set(true);

		const dialogRef = this.dialogService.open(TicketNoCategory, {
			header: 'Ticket senza categoria',
			dismissableMask: true,
			maximizable: true,
			width: '90vw',
			height: '95vh',
			contentStyle: { 'padding': '0 1.5rem', 'display': 'flex', 'min-height': '0' },
			closable: true,
			modal: true,
			baseZIndex: 10000,
			templates: {
				footer: DialogFooterComponent
			}
		});

		dialogRef?.onClose.subscribe(() => {
			this.openSig.set(false);
		});

		return dialogRef?.onClose
	}
}
